import {Component} from 'react';
import {connect} from 'react-redux';

class PersistGate extends Component {

  componentWillReceiveProps(nextProps) {
    // console.log(process.env);
    // console.log(nextProps.isHydrated);
  }

  render() {
    return (this.props.isHydrated ? this.props.children:null);
  }
}

export default connect(state => {
  return {
    isHydrated: state.selection.isHydrated
  };
})(PersistGate);


// WEBPACK FOOTER //
// ./src/components/PersistGate.js